import React from "react";

const ErrorIcon = (props) => {

    return <div className="e-exclamation" onClick={props.onClick}>
        <div className={`e-circle ${props?.success ? 'bg-success' : 'bg-error'}`}></div>
    </div>
}
export default ErrorIcon;